import {
  GET_COMPANY_CONTACT_INFORMATION,
  GET_COMPANY_CONTACT_INFORMATION_ERROR,
  GET_COMPANY_CONTACT_INFORMATION_SUCCESS
} from './CompanyContactSection.actions'

const companyContactInformationState = {
  contacts: [],
  error: undefined,
  loading: true
}

/**
 * The Company Contact Section reducer.
 */
const companyContactInformationReducer = (state = companyContactInformationState, { payload, type }) => {
  switch (type) {
    case GET_COMPANY_CONTACT_INFORMATION: {
      return { ...state, loading: true }
    }
    case GET_COMPANY_CONTACT_INFORMATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        contacts: payload.contacts
      }
    }
    case GET_COMPANY_CONTACT_INFORMATION_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default companyContactInformationReducer
